export const getFAQData = (t: (key: string) => string) => [
  {
    title: t("faqData.whatIsAgntHub.title"),
    text: [
      t("faqData.whatIsAgntHub.text1"),
      t("faqData.whatIsAgntHub.text2"),
      t("faqData.whatIsAgntHub.text3"),
      t("faqData.whatIsAgntHub.text4"),
    ],
  },
  {
    title: t("faqData.prepareBeforeSale.title"),
    text: [t("faqData.prepareBeforeSale.text1")],
  },
  {
    title: t("faqData.joinSale.title"),
    text: [t("faqData.joinSale.text1")],
  },
  {
    title: t("faqData.updatesAndLinks.title"),
    text: [t("faqData.updatesAndLinks.text1")],
  },
];
